import { useLoaderData } from 'react-router';
import { isFeatureEnabledForUser } from '../../../common/utils/featureFlagUtils.js';
import { useAuth } from '../../../public/site/AuthProvider.js';
import { useFeatureFlags } from '../../../public/site/ConfigProvider.js';
import { DnsDomainList } from './DnsDomainList/DnsDomainList.js';
import type { SubscriptionsResponse } from '../../../generated/api/subscriptionsResponse.js';

export const DnsDomainManagement = () => {
  const { searchResults, total } = useLoaderData() as SubscriptionsResponse;
  const { authenticatedUser } = useAuth();
  const featureFlags = useFeatureFlags();

  if (!isFeatureEnabledForUser('dnsManagement', featureFlags, authenticatedUser?.enabledFeatureFlags)) {
    return null;
  }

  return <DnsDomainList searchResults={searchResults} total={total} authenticatedUser={authenticatedUser} />;
};
